import { useMemo } from "react";
import { useMetricsCatalog } from "@/hooks/useMetricsCatalog";
import type { MetricInfo } from "@/types/metrics";

export function useMetricCatalogMap() {
  const { data: catalog } = useMetricsCatalog();
  const catalogMap: Record<string, MetricInfo> = useMemo(() => {
    const map: Record<string, MetricInfo> = {};
    (catalog || []).forEach((m) => {
      const metric = m as MetricInfo;
      const key = metric?.metric_key;
      if (key) map[key] = metric;
    });
    return map;
  }, [catalog]);

  const labelFromCatalog = useMemo(() => (key: string): string => {
    const entry = catalogMap[key] as unknown as { display_name?: string | null; label?: string | null; name?: string | null } | undefined;
    return (entry?.display_name || entry?.label || entry?.name || key);
  }, [catalogMap]);

  return { catalog, catalogMap, labelFromCatalog } as const;
}


